import React from 'react'

const H2HEmptyState = ({ width = '248', height = '192', fill = 'none' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 248 192"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_223_12176)">
        <path
          d="M243.927 121.903C244.168 118.169 244.062 114.423 243.593 110.708C241.401 93.2613 231.469 76.8117 216.847 65.2017C211.633 61.0589 205.695 57.3509 202.304 51.8848C196.586 42.6786 197.018 32.0979 189.924 23.0068C182.822 13.9093 172.472 6.80652 160.801 3.16242C125.996 -7.70597 77.2716 9.99033 81.663 47.7739C81.6772 47.9082 81.6985 48.1064 81.7127 48.3557C82.2944 56.2065 75.4625 62.8043 66.7576 62.9897C34.6482 63.6737 7.00835 85.9859 1.0916 114.244C-2.71102 132.419 3.51789 152.341 18.2672 165.197C29.2778 174.793 44.0555 180.068 58.8402 183.686C88.4808 190.949 119.668 192.47 150.231 189.696C178.835 187.094 209.015 179.684 227.51 159.853C237.386 149.272 243.04 135.706 243.927 121.903Z"
          fill="white"
        />
        <path
          d="M7 191H247"
          stroke="#273754"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M60.4274 46.331L83.4739 42.2285C86.132 41.755 88.8669 42.3211 91.1367 43.8145C93.4064 45.3079 95.0453 47.6196 95.7287 50.2917C97.4061 56.8509 100.105 65.5211 104.979 65.5211C112.291 65.5211 121.948 49.3464 121.948 49.3464L133.32 56.959C133.32 56.959 120.885 84.6702 105.612 85.292C92.5329 85.8255 89.5454 75.3141 89.5454 75.3141V81.4059L52.6969 88.411L58.5779 71.0183C58.5779 71.0183 53.4811 73.8071 48.8091 82.9383C46.9041 86.6616 44.1371 98.157 43.7123 106.853L29.2715 101.201C33.5188 73.3723 38.6156 67.6099 42.4381 61.6322C44.6626 58.1537 50.0786 52.5011 52.6969 50.1332C54.8806 48.1583 57.5566 46.8421 60.4274 46.331Z"
          fill="white"
          stroke="#004360"
          stroke-width="1.4"
          stroke-miterlimit="10"
        />
        <path
          d="M89.5475 81.3451V87.1049C85.7823 88.3474 80.547 89.5889 74.6406 90.1939C68.7179 90.7988 63.2866 90.9973 59.3111 90.7715C55.3356 90.5457 52.8076 89.8935 52.7184 88.798C52.6014 87.357 55.3858 85.6471 59.8846 84.2008C63.5615 83.0192 68.3865 82.0099 73.7173 81.47C79.8544 80.8346 85.5156 80.8346 89.5475 81.3451Z"
          fill="#004360"
        />
        <path
          d="M52.8994 88.7052L58.8314 70.8784"
          stroke="#004360"
          stroke-width="1.4"
          stroke-miterlimit="10"
        />
        <path
          d="M89.5459 75.3068V61.4365"
          stroke="#004360"
          stroke-width="1.4"
          stroke-miterlimit="10"
        />
        <path
          d="M44.058 106.992C43.4734 108.513 39.5352 108.55 35.3823 107.076C31.2293 105.602 28.3359 103.173 28.9228 101.652C29.5096 100.13 33.6394 99.8123 37.7923 101.286C41.9452 102.761 44.6427 105.472 44.058 106.992Z"
          fill="#004360"
        />
        <path
          d="M121.207 49.5165C121.787 48.3727 128.236 40.4041 130.543 40.4597C132.849 40.5154 128.719 43.8774 131.091 43.9383C133.283 43.994 140.324 35.8384 141.453 39.1132C143.371 44.7239 136.575 55.3835 132.558 57.5775C129.211 59.3988 118.944 53.9719 121.207 49.5165Z"
          fill="#C9A2A3"
        />
        <path
          d="M140.481 38.5991C140.481 38.5991 140.201 41.3121 134.076 45.0396"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M141.336 39.6436C141.336 39.6436 141.227 43.2272 135.102 46.9547"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M141.336 39.6436C141.336 39.6436 143.296 44.7701 136.293 48.9576"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M129.18 47.2832C129.18 47.2832 129.693 50.473 128.322 52.9548"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M47.3281 101.91L52.7577 109.779C52.6324 109.934 52.4765 110.125 52.2939 110.346C51.7757 110.974 51.0439 111.843 50.1903 112.804C48.4743 114.738 46.2977 117.012 44.3836 118.478C42.8731 119.635 40.7834 120.858 39.0497 121.8C38.1872 122.269 37.4208 122.664 36.8702 122.942C36.7219 123.017 36.5892 123.083 36.4747 123.14L31.0477 115.274C31.0881 115.254 31.1298 115.233 31.1729 115.211C31.7326 114.929 32.5114 114.527 33.3885 114.051C35.134 113.102 37.3011 111.838 38.9007 110.612C40.9277 109.06 43.1795 106.699 44.9067 104.753C45.7745 103.776 46.518 102.893 47.0446 102.255C47.1476 102.13 47.2423 102.015 47.3281 101.91Z"
          fill="white"
          stroke="#1D2943"
          stroke-width="1.4"
        />
        <path
          d="M48.837 103.24L53.8657 111.427C53.733 111.574 53.5681 111.756 53.3752 111.965C52.8265 112.561 52.0524 113.385 51.1519 114.295C49.3419 116.123 47.0554 118.264 45.0717 119.614C43.5063 120.679 41.3592 121.776 39.5812 122.614C38.6967 123.03 37.9118 123.379 37.3483 123.624C37.1968 123.69 37.0615 123.748 36.9446 123.798L31.9182 115.615C31.9581 115.598 31.9992 115.58 32.0416 115.562C32.6146 115.313 33.4124 114.958 34.312 114.534C36.1023 113.69 38.3297 112.557 39.9887 111.428C42.0911 109.997 44.4581 107.774 46.2801 105.933C47.1957 105.008 47.9822 104.171 48.5401 103.565C48.6478 103.448 48.747 103.339 48.837 103.24Z"
          fill="white"
          stroke="#1D2943"
          stroke-width="1.4"
        />
        <path
          d="M48.6313 106.178L53.3029 114.618C53.1642 114.758 52.992 114.931 52.7907 115.13C52.2169 115.697 51.4083 116.481 50.4699 117.343C48.5833 119.077 46.2077 121.099 44.169 122.345C42.5601 123.329 40.3689 124.314 38.557 125.06C37.6557 125.432 36.8568 125.74 36.2834 125.956C36.1298 126.014 35.9924 126.065 35.8737 126.108L31.2044 117.672C31.2436 117.657 31.2841 117.642 31.3258 117.626C31.9089 117.407 32.721 117.094 33.6379 116.716C35.4625 115.965 37.7364 114.946 39.4426 113.903C41.6048 112.581 44.0652 110.48 45.9644 108.734C46.9188 107.857 47.7405 107.061 48.3239 106.484C48.4353 106.373 48.538 106.271 48.6313 106.178Z"
          fill="white"
          stroke="#1D2943"
          stroke-width="1.4"
        />
        <path
          d="M30.1305 103.093C30.1305 103.093 30.3472 114.208 38.5702 119.96C45.7108 124.956 48.9952 120.096 48.032 119.219C44.064 115.604 42.1192 110.147 42.3601 106.735C42.5227 104.457 33.0612 99.5007 30.1305 103.093Z"
          fill="#C9A2A3"
        />
        <path
          d="M46.9206 121.169C46.9206 121.169 42.1578 119.038 41.011 114.401"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M44.214 121.877C44.214 121.877 40.0648 119.773 38.5413 115.798"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M41.7219 121.392C41.7219 121.392 37.1719 119.896 36.0579 115.784"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M89.546 81.0897V167.74H71.7614V127.264C68.3153 144.699 37.1206 160.57 37.1206 160.57L28.4001 144.7C28.4001 144.7 52.048 134.626 56.8627 109.243C57.9266 103.632 58.7576 96.2392 59.3055 90.5161C59.5599 87.8452 59.7528 85.5377 59.879 83.9455C63.556 82.7639 68.3809 81.7545 73.7117 81.2147C79.853 80.5792 85.5141 80.5792 89.546 81.0897Z"
          fill="#C9A2A3"
        />
        <path
          d="M64.2575 139.98C62.4108 138.454 62.1471 135.341 63.7137 132.764C65.385 130.014 68.513 128.914 70.6993 130.307"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M89.2426 140.561C86.883 140.358 84.9501 137.935 84.8311 134.905C84.7028 131.67 86.686 128.96 89.259 128.854"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M89.5464 81.0897V110.845C68.1238 114.296 56.8672 109.243 56.8672 109.243C57.9311 103.632 58.7621 96.2392 59.3099 90.5161C59.5644 87.8452 59.7573 85.5377 59.8834 83.9455C63.5604 82.7639 68.3854 81.7545 73.7162 81.2147C79.8533 80.5792 85.5144 80.5792 89.5464 81.0897Z"
          fill="#7E7EB9"
        />
        <path
          d="M71.7617 128.193C77.0874 112.945 77.8147 97.6963 77.8147 97.6963"
          stroke="white"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M61.5066 110.314C62.907 102.93 63.9996 93.2002 64.7209 85.6685"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M60.1221 110.035C61.5225 102.651 62.6151 92.9219 63.3363 85.3901"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M89.5467 81.0897V86.8495C85.7815 88.092 80.5462 89.3335 74.6399 89.9385C68.7171 90.5435 63.2858 90.742 59.3103 90.5161C59.5647 87.8452 59.7576 85.5377 59.8838 83.9455C63.5608 82.7639 68.3857 81.7545 73.7165 81.2147C79.8537 80.5792 85.5148 80.5792 89.5467 81.0897Z"
          fill="#1D2943"
        />
        <path
          d="M73.6557 187.979C74.7028 187.979 75.5516 187.11 75.5516 186.038C75.5516 184.966 74.7028 184.097 73.6557 184.097C72.6086 184.097 71.7598 184.966 71.7598 186.038C71.7598 187.11 72.6086 187.979 73.6557 187.979Z"
          fill="white"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M80.5158 187.979C81.5629 187.979 82.4117 187.11 82.4117 186.038C82.4117 184.966 81.5629 184.097 80.5158 184.097C79.4687 184.097 78.6199 184.966 78.6199 186.038C78.6199 187.11 79.4687 187.979 80.5158 187.979Z"
          fill="white"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M87.3769 187.979C88.424 187.979 89.2728 187.11 89.2728 186.038C89.2728 184.966 88.424 184.097 87.3769 184.097C86.3298 184.097 85.481 184.966 85.481 186.038C85.481 187.11 86.3298 187.979 87.3769 187.979Z"
          fill="white"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M94.2365 187.979C95.2836 187.979 96.1324 187.11 96.1324 186.038C96.1324 184.966 95.2836 184.097 94.2365 184.097C93.1894 184.097 92.3406 184.966 92.3406 186.038C92.3406 187.11 93.1894 187.979 94.2365 187.979Z"
          fill="white"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M96.1332 181.723V183.08H75.5847C74.5705 183.08 73.5979 182.667 72.8808 181.933C72.1638 181.199 71.761 180.203 71.761 179.164V167.739H89.5456C89.5456 170.155 89.4646 176.185 94.8743 179.46C95.2583 179.692 95.5764 180.023 95.7972 180.42C96.018 180.817 96.1338 181.266 96.1332 181.723Z"
          fill="#004360"
        />
        <path
          d="M89.827 170.048C90.7031 170.17 91.1945 170.363 91.1945 170.693C91.1945 171.135 89.6556 171.309 86.9595 171.309"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M90.2538 172.726C91.1648 172.838 91.648 173.133 91.648 173.478C91.648 173.92 89.6597 174.003 86.9595 174.003"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M86.9612 176.743C86.9612 176.743 92.7064 177.153 92.7064 176.007C92.7064 175.519 91.8713 175.345 91.1952 175.284"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M89.5456 164.182H71.761V167.74H89.5456V164.182Z"
          fill="white"
        />
        <path
          d="M13.7521 157.3C14.7992 157.3 15.6481 156.431 15.6481 155.359C15.6481 154.287 14.7992 153.418 13.7521 153.418C12.705 153.418 11.8562 154.287 11.8562 155.359C11.8562 156.431 12.705 157.3 13.7521 157.3Z"
          fill="white"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M17.1152 163.421C18.1623 163.421 19.0111 162.552 19.0111 161.481C19.0111 160.409 18.1623 159.54 17.1152 159.54C16.0681 159.54 15.2192 160.409 15.2192 161.481C15.2192 162.552 16.0681 163.421 17.1152 163.421Z"
          fill="white"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M20.4765 169.544C21.5236 169.544 22.3724 168.675 22.3724 167.603C22.3724 166.531 21.5236 165.662 20.4765 165.662C19.4294 165.662 18.5806 166.531 18.5806 167.603C18.5806 168.675 19.4294 169.544 20.4765 169.544Z"
          fill="white"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M23.8403 175.667C24.8874 175.667 25.7362 174.798 25.7362 173.726C25.7362 172.654 24.8874 171.785 23.8403 171.785C22.7932 171.785 21.9443 172.654 21.9443 173.726C21.9443 174.798 22.7932 175.667 23.8403 175.667Z"
          fill="white"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M28.4427 173.302L27.2875 173.966L17.2158 155.631C16.7189 154.726 16.5935 153.656 16.8673 152.656C17.1411 151.656 17.7916 150.808 18.6757 150.299L28.4037 144.7L37.1242 160.569C35.0723 161.752 29.8944 164.637 29.7569 171.072C29.7462 171.528 29.6193 171.974 29.3888 172.365C29.1584 172.756 28.8322 173.079 28.4427 173.302Z"
          fill="#004360"
        />
        <path
          d="M35.1622 161.978C35.4884 162.818 35.5315 163.477 35.2494 163.64C34.8718 163.857 33.9731 162.572 32.6497 160.162"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M32.9663 163.898C33.4105 164.882 33.4793 165.552 33.1561 165.737C32.7796 165.954 31.6582 164.267 30.3337 161.851"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M27.8857 163.292C27.8857 163.292 30.3541 168.531 31.3329 167.967C31.7679 167.717 31.4611 166.946 31.1687 166.332"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M28.4036 144.7L32.6499 142.447L41.6443 158.191L37.2112 160.663L28.4036 144.7Z"
          fill="white"
        />
        <path
          d="M80.3832 30.8535C80.3832 34.7973 76.7075 37.561 72.8138 37.561C71.2617 37.5634 69.7523 37.0445 68.5199 36.0847C67.2875 35.1248 66.4012 33.7779 65.9986 32.2531C65.5851 33.3507 64.8918 34.3165 63.9898 35.0511C63.0878 35.7858 62.0098 36.2629 60.8665 36.4332C59.7232 36.6036 58.556 36.4611 57.4848 36.0204C56.4136 35.5798 55.4771 34.8568 54.7716 33.9259C54.476 36.7059 53.2009 39.283 51.1821 41.1807C49.1633 43.0783 46.5373 44.1681 43.7898 44.2486C41.0422 44.3291 38.3589 43.3948 36.2361 41.6184C34.1133 39.8421 32.6946 37.3439 32.2423 34.5859C31.7899 31.8278 32.3346 28.9964 33.7756 26.6152C35.2166 24.2341 37.4564 22.4642 40.0808 21.633C42.7053 20.8018 45.5368 20.9654 48.0518 22.0935C50.5669 23.2217 52.5953 25.2381 53.762 27.7699C54.2055 26.4359 55.0557 25.2806 56.189 24.472C57.3223 23.6633 58.6797 23.2435 60.0637 23.2736C61.4477 23.3036 62.7861 23.782 63.8845 24.6392C64.9828 25.4963 65.7838 26.6875 66.1708 28.0396C66.6599 26.6443 67.5616 25.4374 68.7522 24.5846C69.9428 23.7318 71.3637 23.2751 72.8198 23.277C76.7075 23.2795 80.3832 26.9096 80.3832 30.8535Z"
          fill="#2E3860"
        />
        <path
          d="M25.9218 36.8895C27.6244 36.8895 29.0046 35.4765 29.0046 33.7336C29.0046 31.9906 27.6244 30.5776 25.9218 30.5776C24.2193 30.5776 22.8391 31.9906 22.8391 33.7336C22.8391 35.4765 24.2193 36.8895 25.9218 36.8895Z"
          fill="#2E3860"
        />
        <path
          d="M69.4513 37.322L66.8167 44.8841C66.8167 44.8841 67.74 48.1296 73.1549 47.8418C78.5698 47.554 77.9696 42.9537 77.9696 42.9537V40.1179L71.3677 37.2358L69.4513 37.322Z"
          fill="#C9A2A3"
        />
        <path
          d="M77.9696 41.1046L67.0803 45.4475C66.9709 45.2713 66.8824 45.0823 66.8167 44.8846L69.4526 36.7821L71.368 36.6938L77.9635 40.0858V40.1215L77.9696 41.1046Z"
          fill="#1D2943"
        />
        <path
          d="M76.7631 41.4243C74.167 41.5411 71.6452 39.4646 70.6436 36.4796H68.228C67.9018 36.4796 67.5789 36.4138 67.2776 36.2861C66.9763 36.1583 66.7026 35.971 66.472 35.735C66.2414 35.4989 66.0585 35.2186 65.9337 34.9102C65.8089 34.6017 65.7446 34.2711 65.7446 33.9373C65.7446 33.6034 65.8089 33.2728 65.9337 32.9644C66.0585 32.6559 66.2414 32.3757 66.472 32.1396C66.7026 31.9035 66.9763 31.7163 67.2776 31.5885C67.5789 31.4607 67.9018 31.395 68.228 31.395H70.4831C70.4831 31.395 70.4831 31.395 70.4831 31.3868C70.5547 31.3923 70.6304 31.395 70.71 31.395C73.8486 31.395 77.3162 27.9509 77.3202 26.3701C79.8991 27.0736 80.9855 29.9174 81.142 33.5489C81.3251 37.7494 80.0118 41.2776 76.7631 41.4243Z"
          fill="#C9A2A3"
        />
        <path
          d="M69.7727 34.2561C69.7727 33.8159 69.6019 33.3936 69.298 33.0822C68.994 32.7707 68.5817 32.5956 68.1516 32.5952"
          stroke="#2E3860"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M74.787 35.3971C75.0463 35.3971 75.2566 35.0748 75.2566 34.6773C75.2566 34.2798 75.0463 33.9575 74.787 33.9575C74.5276 33.9575 74.3174 34.2798 74.3174 34.6773C74.3174 35.0748 74.5276 35.3971 74.787 35.3971Z"
          fill="#423C52"
        />
        <path
          d="M79.8297 35.3371C80.0671 35.3371 80.2595 35.0416 80.2595 34.6771C80.2595 34.3126 80.0671 34.0171 79.8297 34.0171C79.5923 34.0171 79.3999 34.3126 79.3999 34.6771C79.3999 35.0416 79.5923 35.3371 79.8297 35.3371Z"
          fill="#423C52"
        />
        <path
          d="M72.8157 32.7005C72.8157 32.7005 73.8517 31.6032 75.9994 31.8761"
          stroke="#2E3860"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M81.0952 31.603C81.0952 31.603 77.9884 31.603 78.0919 36.9891"
          stroke="#2E3860"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M75.3024 37.6679C75.3024 37.6679 75.9468 39.1361 77.5032 38.729"
          stroke="#2E3860"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M131.552 30.1065C131.606 29.7377 131.907 29.4549 132.279 29.4246L140.338 28.7658C140.87 28.7224 141.294 29.2013 141.187 29.7238L136.438 52.9006C136.362 53.2727 136.034 53.54 135.654 53.54H128.446C127.927 53.54 127.545 53.0537 127.669 52.5498L129.424 45.3751C129.438 45.3193 129.458 45.2652 129.483 45.2136L129.809 44.5479L129.18 44.2402L129.809 44.5479C129.828 44.5089 129.849 44.4729 129.874 44.4369L129.3 44.0359L129.874 44.4369C130.05 44.1857 130.536 43.4844 130.98 42.7914C131.201 42.4462 131.418 42.0931 131.582 41.7945C131.664 41.6461 131.738 41.4994 131.795 41.3672C131.837 41.2688 131.919 41.0688 131.919 40.8588C131.919 40.3532 131.661 39.9996 131.384 39.7706C131.153 39.5793 130.868 39.4411 130.673 39.3467C130.659 39.3402 130.646 39.334 130.634 39.3279C130.421 39.2243 130.306 39.1626 130.24 39.1105L131.552 30.1065Z"
          fill="white"
          stroke="#273754"
          stroke-width="1.4"
        />
        <path
          d="M231.365 85.9069C231.365 85.9069 232.856 94.5663 218.215 92.6597L217.508 83.1948L231.365 85.9069Z"
          fill="white"
          stroke="#004360"
          stroke-width="1.4"
          stroke-miterlimit="10"
        />
        <path
          d="M185.686 187.979C177.777 187.979 171.365 178.706 171.365 167.269C171.365 155.831 177.777 146.559 185.686 146.559C193.596 146.559 200.008 155.831 200.008 167.269C200.008 178.706 193.596 187.979 185.686 187.979Z"
          fill="white"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M186.18 184.694C180.598 184.694 176.073 177.407 176.073 168.419C176.073 159.431 180.598 152.145 186.18 152.145C191.761 152.145 196.286 159.431 196.286 168.419C196.286 177.407 191.761 184.694 186.18 184.694Z"
          fill="#D0D0F0"
        />
        <path
          d="M187.779 183.543C182.197 183.543 177.672 176.257 177.672 167.269C177.672 158.28 182.197 150.994 187.779 150.994C193.361 150.994 197.885 158.28 197.885 167.269C197.885 176.257 193.361 183.543 187.779 183.543Z"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M215.688 169.232L216.329 170.891C216.56 171.49 216.643 172.138 216.57 172.776C216.497 173.415 216.271 174.027 215.911 174.557C215.55 175.088 215.067 175.523 214.502 175.823C213.938 176.123 213.309 176.28 212.671 176.28H188.622C188.622 176.28 188.084 174.393 191.367 173.179C193.796 172.281 195.662 170.773 195.203 167.845L215.688 169.232Z"
          fill="#423C52"
        />
        <path
          d="M231.589 169.232L232.229 170.891C232.46 171.49 232.543 172.137 232.47 172.776C232.397 173.415 232.171 174.026 231.811 174.557C231.45 175.088 230.967 175.522 230.403 175.822C229.838 176.123 229.21 176.28 228.572 176.28H204.264C204.264 176.28 208.737 172.756 208.643 169.227L231.589 169.232Z"
          fill="#423C52"
        />
        <path
          d="M204.262 176.281C204.262 176.281 208.735 172.756 208.641 169.227"
          stroke="white"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M217.717 83.8279C222.038 142.127 231.589 169.232 231.589 169.232C231.589 169.232 209.422 170.39 195.202 167.845C195.202 167.845 182.013 132.883 180.522 78.2627L217.717 83.8279Z"
          fill="#7E7EB9"
        />
        <path
          d="M228.006 156.203V169.371L228.349 169.36V157.629C228.247 157.212 228.143 156.785 228.035 156.345L228.006 156.203Z"
          fill="#2E3860"
        />
        <path
          d="M224.595 139.789V169.45H224.938V141.645C224.825 141.035 224.71 140.417 224.595 139.789Z"
          fill="#2E3860"
        />
        <path
          d="M221.184 117.931V169.495H221.527V120.47C221.439 119.838 221.354 119.197 221.267 118.549C221.252 118.435 221.237 118.319 221.22 118.204C221.207 118.117 221.198 118.021 221.184 117.931Z"
          fill="#2E3860"
        />
        <path
          d="M217.776 84.6011V169.487H218.117V88.9682C218.081 88.5218 218.046 88.074 218.013 87.6248L217.985 87.2794C217.912 86.3951 217.843 85.5023 217.776 84.6011Z"
          fill="#2E3860"
        />
        <path
          d="M214.365 83.3267V169.437L214.707 169.444V83.374L214.365 83.3267Z"
          fill="#2E3860"
        />
        <path
          d="M210.953 82.8154V169.335L211.295 169.349V82.8681L210.953 82.8154Z"
          fill="#2E3860"
        />
        <path
          d="M207.544 82.3057V169.179L207.886 169.198V82.3583L207.544 82.3057Z"
          fill="#2E3860"
        />
        <path
          d="M204.132 81.7944V168.941L204.475 168.968V81.846L204.132 81.7944Z"
          fill="#2E3860"
        />
        <path
          d="M200.724 81.2852V168.621L201.066 168.658V81.3357L200.724 81.2852Z"
          fill="#2E3860"
        />
        <path
          d="M197.311 80.7754V168.189L197.654 168.239V80.827L197.311 80.7754Z"
          fill="#2E3860"
        />
        <path
          d="M193.9 80.2646V164.027C194.021 164.404 194.135 164.755 194.242 165.08V80.3205L193.9 80.2646Z"
          fill="#2E3860"
        />
        <path
          d="M190.49 79.7544V152.141L190.6 152.562C190.63 152.678 190.66 152.794 190.689 152.908C190.738 153.092 190.786 153.273 190.833 153.453V79.806L190.49 79.7544Z"
          fill="#2E3860"
        />
        <path
          d="M187.08 79.2446V137.219C187.188 137.759 187.297 138.292 187.407 138.82L187.422 138.897V79.2952L187.08 79.2446Z"
          fill="#2E3860"
        />
        <path
          d="M183.669 78.7329V116.959C183.726 117.38 183.784 117.79 183.841 118.204C183.858 118.319 183.875 118.435 183.89 118.549C183.93 118.833 183.972 119.117 184.012 119.399V78.7856L183.669 78.7329Z"
          fill="#2E3860"
        />
        <path
          d="M180.521 78.2627C180.54 78.9807 180.562 79.6952 180.588 80.4062C180.588 80.521 180.595 80.6368 180.598 80.7516C180.598 80.7589 180.598 80.7663 180.598 80.7737V78.2743L180.521 78.2627Z"
          fill="#2E3860"
        />
        <path
          d="M194.658 166.308C194.699 166.43 194.738 166.544 194.775 166.653H230.77L230.665 166.308H194.658Z"
          fill="#2E3860"
        />
        <path
          d="M193.534 162.872C193.571 162.989 193.606 163.104 193.639 163.217H229.789C229.759 163.103 229.727 162.989 229.695 162.872H193.534Z"
          fill="#2E3860"
        />
        <path
          d="M192.493 159.437C192.526 159.552 192.561 159.668 192.598 159.781H228.886C228.855 159.668 228.827 159.552 228.798 159.437H192.493Z"
          fill="#2E3860"
        />
        <path
          d="M191.518 156C191.549 156.115 191.581 156.231 191.613 156.344H228.041L228.006 156.202V156H191.518Z"
          fill="#2E3860"
        />
        <path
          d="M190.599 152.564C190.629 152.68 190.659 152.796 190.689 152.909H227.247C227.222 152.796 227.197 152.68 227.171 152.564H190.599Z"
          fill="#2E3860"
        />
        <path
          d="M189.732 149.128C189.76 149.244 189.788 149.36 189.816 149.473H226.497C226.473 149.36 226.448 149.244 226.424 149.128H189.732Z"
          fill="#2E3860"
        />
        <path
          d="M188.915 145.691C188.941 145.806 188.969 145.921 188.995 146.036H225.792C225.769 145.921 225.745 145.806 225.722 145.691H188.915Z"
          fill="#2E3860"
        />
        <path
          d="M188.138 142.255C188.163 142.372 188.188 142.486 188.213 142.6H225.12C225.098 142.486 225.076 142.372 225.055 142.255H188.138Z"
          fill="#2E3860"
        />
        <path
          d="M187.406 138.82L187.422 138.898L187.478 139.164H224.482C224.461 139.051 224.44 138.936 224.419 138.82H187.406Z"
          fill="#2E3860"
        />
        <path
          d="M186.721 135.383C186.742 135.498 186.765 135.614 186.788 135.727H223.876L223.817 135.383H186.721Z"
          fill="#2E3860"
        />
        <path
          d="M186.065 131.948C186.087 132.064 186.107 132.178 186.128 132.293H223.297C223.279 132.178 223.26 132.064 223.242 131.948H186.065Z"
          fill="#2E3860"
        />
        <path
          d="M185.454 128.512C185.475 128.628 185.493 128.742 185.513 128.857H222.755C222.736 128.742 222.718 128.629 222.701 128.512H185.454Z"
          fill="#2E3860"
        />
        <path
          d="M184.88 125.076C184.899 125.191 184.918 125.305 184.935 125.42H222.233C222.215 125.305 222.199 125.191 222.182 125.076H184.88Z"
          fill="#2E3860"
        />
        <path
          d="M184.342 121.64C184.358 121.754 184.376 121.869 184.394 121.983H221.737C221.721 121.869 221.705 121.754 221.688 121.64H184.342Z"
          fill="#2E3860"
        />
        <path
          d="M183.841 118.204C183.858 118.319 183.875 118.434 183.891 118.548H221.268C221.253 118.434 221.237 118.319 221.221 118.204H183.841Z"
          fill="#2E3860"
        />
        <path
          d="M183.377 114.769L183.422 115.113H220.821C220.806 114.998 220.79 114.884 220.777 114.769H183.377Z"
          fill="#2E3860"
        />
        <path
          d="M182.946 111.331C182.959 111.446 182.972 111.56 182.987 111.675H220.4C220.387 111.56 220.373 111.446 220.359 111.331H182.946Z"
          fill="#2E3860"
        />
        <path
          d="M182.548 107.895C182.562 108.01 182.574 108.124 182.587 108.24H219.999C219.986 108.124 219.973 108.01 219.96 107.895H182.548Z"
          fill="#2E3860"
        />
        <path
          d="M182.187 104.458C182.199 104.573 182.21 104.687 182.223 104.803H219.615L219.577 104.458H182.187Z"
          fill="#2E3860"
        />
        <path
          d="M181.859 101.022C181.87 101.137 181.88 101.251 181.892 101.367H219.255C219.243 101.251 219.231 101.137 219.22 101.022H181.859Z"
          fill="#2E3860"
        />
        <path
          d="M181.564 97.5869L181.592 97.9315H218.914L218.88 97.5869H181.564Z"
          fill="#2E3860"
        />
        <path
          d="M181.303 94.1509C181.312 94.2654 181.321 94.3809 181.328 94.4954H218.595C218.584 94.3809 218.574 94.2654 218.564 94.1509H181.303Z"
          fill="#2E3860"
        />
        <path
          d="M181.078 90.7144C181.085 90.8289 181.093 90.9444 181.099 91.0589H218.293C218.283 90.9444 218.273 90.8289 218.263 90.7144H181.078Z"
          fill="#2E3860"
        />
        <path
          d="M180.881 87.2788C180.886 87.3933 180.892 87.5089 180.899 87.6234H218.009L217.981 87.2788H180.881Z"
          fill="#2E3860"
        />
        <path
          d="M180.718 83.8433C180.718 83.9578 180.728 84.0733 180.733 84.1878H217.776V83.8433H180.718Z"
          fill="#2E3860"
        />
        <path
          d="M180.589 80.4062C180.589 80.5207 180.596 80.6363 180.599 80.7508H197.155L194.848 80.4062H180.589Z"
          fill="#2E3860"
        />
        <path
          d="M208.641 169.231C208.62 164.957 196.005 94.7096 195.431 94.0168C194.858 93.3241 192.565 92.7461 192.565 92.7461"
          stroke="white"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M180.522 78.2627L217.832 83.8279L218.484 92.9201L180.522 79.4598V78.2627Z"
          fill="#1D2943"
        />
        <path
          d="M233.677 179.312H188.62V176.279H233.677V179.312Z"
          fill="white"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M230.707 187.979C222.797 187.979 216.385 178.707 216.385 167.269C216.385 155.831 222.797 146.559 230.707 146.559C238.616 146.559 245.028 155.831 245.028 167.269C245.028 178.707 238.616 187.979 230.707 187.979Z"
          fill="white"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M231.657 184.693C226.075 184.693 221.55 177.407 221.55 168.419C221.55 159.43 226.075 152.144 231.657 152.144C237.239 152.144 241.764 159.43 241.764 168.419C241.764 177.407 237.239 184.693 231.657 184.693Z"
          fill="#D0D0F0"
        />
        <path
          d="M233.026 183.543C227.444 183.543 222.919 176.257 222.919 167.269C222.919 158.28 227.444 150.994 233.026 150.994C238.608 150.994 243.133 158.28 243.133 167.269C243.133 176.257 238.608 183.543 233.026 183.543Z"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M180.522 78.2631V70.7407C180.522 70.7407 178.362 85.0885 167.104 84.2589C153.426 83.2503 153.176 54.7062 181.322 36.8577C183.02 35.7823 184.931 35.0935 186.921 34.8395L196.865 34.0225L219.191 37.4715C221.585 37.8899 223.851 38.8605 225.811 40.3073C227.771 41.7542 229.372 43.6382 230.489 45.8119C234.983 54.5756 241.278 69.5794 237.804 79.4864C235.213 86.8846 226.549 89.1345 217.718 86.0139L180.522 78.2631Z"
          fill="#2E3860"
        />
        <path
          d="M180.523 70.7375V63.0972"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M215.67 62.0059L227.429 66.9162"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M217.735 86.1123C214.774 85.1395 204.078 77.3665 200.769 68.0259"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M199.949 60.9933C199.684 46.9382 208.359 36.0278 211.352 36.0773L220.794 36.0688C221.116 36.0686 221.436 36.1324 221.734 36.2566C222.032 36.3808 222.303 36.563 222.532 36.7928C222.76 37.0225 222.941 37.2954 223.064 37.5957C223.188 37.896 223.252 38.2179 223.252 38.543C220.797 37.9039 211.007 34.9097 207.046 62.821L199.949 60.9933Z"
          fill="white"
          stroke="#004360"
          stroke-width="1.4"
          stroke-miterlimit="10"
        />
        <path
          d="M196.865 34.1377C196.865 34.1377 183.677 36.4897 180.523 62.825C180.523 62.825 175.984 47.7812 184.389 35.9959C184.771 35.4594 185.272 35.021 185.853 34.716C186.434 34.4111 187.079 34.2484 187.734 34.2409L196.865 34.1377Z"
          fill="white"
          stroke="#004360"
          stroke-width="1.4"
          stroke-miterlimit="10"
        />
        <path
          d="M171.156 66.2919C166.801 65.5828 163.616 62.8503 164.043 60.1886C164.47 57.5269 168.347 55.944 172.702 56.6531C177.057 57.3622 180.242 60.0947 179.815 62.7564C179.388 65.4181 175.511 67.001 171.156 66.2919Z"
          fill="#423C52"
        />
        <path
          d="M165.983 64.1363L166.366 64.4269C167.614 65.3197 169.276 66.0061 171.158 66.3104C173.811 66.742 176.285 66.3241 177.911 65.3302L178.84 62.9382L180.52 63.0961C180.925 63.1338 181.332 63.0465 181.686 62.8459C182.041 62.6453 182.327 62.3408 182.506 61.9728L186.616 53.506C186.771 53.179 186.848 52.8195 186.84 52.4569C186.831 52.0943 186.737 51.7389 186.566 51.4198C186.395 51.1008 186.151 50.827 185.855 50.6211C185.558 50.4151 185.218 50.2828 184.861 50.2349L177.47 49.2452C176.502 49.115 175.517 49.2851 174.647 49.733C173.777 50.1808 173.063 50.8851 172.601 51.752L165.983 64.1363Z"
          fill="#FFDADB"
        />
        <path
          d="M185.178 55.8002C185.334 55.4731 185.411 55.1134 185.403 54.7505C185.395 54.3877 185.301 54.032 185.13 53.7126C184.959 53.3932 184.715 53.1193 184.418 52.9132C184.122 52.7071 183.781 52.5747 183.424 52.527L179.335 51.9795"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M183.794 58.7019C183.95 58.3749 184.026 58.0154 184.018 57.6528C184.009 57.2902 183.915 56.9348 183.744 56.6157C183.573 56.2967 183.329 56.0229 183.033 55.817C182.737 55.611 182.396 55.4787 182.039 55.4308L177.951 54.8833"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M182.384 61.5149C182.54 61.1879 182.617 60.8284 182.608 60.4658C182.6 60.1032 182.506 59.7478 182.335 59.4287C182.164 59.1097 181.92 58.8359 181.623 58.63C181.327 58.424 180.987 58.2917 180.63 58.2438L176.543 57.6963"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M200.611 68.0088C199.983 66.2243 202.982 63.5258 207.308 61.9816C211.634 60.4374 215.649 60.6323 216.277 62.4168C216.905 64.2013 213.906 66.8998 209.58 68.444C205.254 69.9882 201.239 69.7933 200.611 68.0088Z"
          fill="#423C52"
        />
        <path
          d="M200.569 67.8707C201.447 68.4918 203.63 68.5213 206.027 68.0812C208.796 67.5664 211.054 66.3093 211.199 65.2176L211.194 64.9649L211.04 57.6562C211.02 56.6722 210.703 55.7179 210.13 54.9202C209.558 54.1225 208.758 53.5194 207.837 53.1912L200.809 50.6823C200.47 50.5614 200.107 50.5231 199.751 50.5705C199.394 50.6179 199.053 50.7497 198.757 50.955C198.46 51.1604 198.216 51.4335 198.045 51.7521C197.873 52.0706 197.779 52.4256 197.769 52.788L197.603 62.2118C197.596 62.6215 197.712 63.0238 197.938 63.3652C198.163 63.7065 198.486 63.9707 198.863 64.1226L200.431 64.7543L200.569 67.8707Z"
          fill="#FFDADB"
        />
        <path
          d="M197.704 55.5872C197.714 55.2248 197.808 54.8697 197.979 54.551C198.151 54.2323 198.395 53.9591 198.692 53.7537C198.988 53.5483 199.329 53.4165 199.686 53.3692C200.042 53.3219 200.405 53.3604 200.745 53.4816L204.632 54.8681"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M197.678 58.7015C197.687 58.339 197.781 57.9839 197.953 57.6652C198.125 57.3466 198.369 57.0733 198.665 56.8679C198.962 56.6625 199.302 56.5308 199.659 56.4835C200.016 56.4362 200.379 56.4747 200.718 56.5958L204.604 57.9824"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M197.612 61.699C197.621 61.3366 197.715 60.9815 197.887 60.6628C198.059 60.3441 198.303 60.0709 198.599 59.8655C198.896 59.6601 199.236 59.5283 199.593 59.481C199.95 59.4338 200.313 59.4722 200.652 59.5934L204.54 60.9799"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M208.853 26.8101V34.6637C208.853 34.6637 203.672 41.9007 196.923 39.9764C191.862 38.5341 198.057 32.7722 198.057 32.7722V26.8101H208.853Z"
          fill="#FFDADB"
        />
        <path
          d="M198.058 26.8101V32.7722L206.937 36.7786C206.937 36.7786 208.853 35.0583 208.853 34.6662V26.8101H198.058Z"
          fill="#423C52"
        />
        <path
          d="M209.639 22.4003L206.77 22.2946C206.513 21.7177 206.11 21.2187 205.602 20.8475C204.991 20.3987 204.254 20.1575 203.498 20.1591H198.548C198.359 20.1588 198.171 20.1759 197.986 20.2101C197.878 20.2284 197.771 20.2536 197.665 20.2854C197.561 20.3014 197.456 20.3095 197.351 20.3097C195.945 20.3097 194.805 18.8892 194.805 17.1361C194.805 15.3831 195.945 13.9614 197.351 13.9614C197.68 13.968 198.003 14.0459 198.3 14.1898C198.596 14.3337 198.858 14.5403 199.068 14.7955C199.55 13.7611 200.435 13.0679 201.446 13.0679C202.566 13.0679 203.532 13.9177 203.967 15.1463C204.205 14.9017 204.489 14.707 204.802 14.5732C205.116 14.4395 205.452 14.3694 205.792 14.3669C206.976 14.3669 207.987 15.207 208.382 16.3919C208.382 16.3919 210.639 15.4377 211.636 16.8205C212.633 18.2033 209.639 22.4003 209.639 22.4003Z"
          fill="#423C52"
        />
        <path
          d="M195.857 22.5645V28.6754C195.857 29.6081 196.185 30.5025 196.769 31.162C197.353 31.8216 198.145 32.1922 198.971 32.1926H203.37C204.466 32.1925 205.517 31.707 206.298 30.8405C207.08 29.9741 207.529 28.7958 207.55 27.5591H209.601C210.196 27.5591 210.766 27.2923 211.187 26.8173C211.607 26.3424 211.844 25.6982 211.844 25.0265C211.844 24.3548 211.607 23.7106 211.187 23.2356C210.766 22.7607 210.196 22.4938 209.601 22.4938H207.437C207.267 21.809 206.904 21.2056 206.402 20.7758C205.9 20.346 205.288 20.1133 204.658 20.1133H198.029C197.454 20.1133 196.901 20.3714 196.494 20.831C196.087 21.2907 195.857 21.9141 195.857 22.5645Z"
          fill="#FFDADB"
        />
        <path
          d="M198.884 29.5407C198.884 29.5407 200.912 31.0507 201.808 28.4268Z"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M207.628 25.122C207.628 24.6811 207.802 24.2583 208.112 23.9467C208.421 23.635 208.841 23.46 209.279 23.46"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M195.399 22.89C195.399 22.89 197.13 22.4663 198.061 23.7544C198.73 24.6807 198.456 27.456 198.456 27.456"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M201.164 22.9225C201.164 22.9225 202.862 22.7117 204.188 23.1563"
          stroke="#423C52"
          stroke-width="1.4"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M196.629 26.0685C196.353 26.0685 196.129 25.7305 196.129 25.3136C196.129 24.8966 196.353 24.5586 196.629 24.5586C196.905 24.5586 197.128 24.8966 197.128 25.3136C197.128 25.7305 196.905 26.0685 196.629 26.0685Z"
          fill="#423C52"
        />
        <path
          d="M202.202 26.0685C201.926 26.0685 201.702 25.7305 201.702 25.3136C201.702 24.8966 201.926 24.5586 202.202 24.5586C202.478 24.5586 202.701 24.8966 202.701 25.3136C202.701 25.7305 202.478 26.0685 202.202 26.0685Z"
          fill="#423C52"
        />
      </g>
      <defs>
        <clipPath id="clip0_223_12176">
          <rect width="248" height="192" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default H2HEmptyState
